import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {UserAvatar} from '@components/user-avatar'
import {cn} from '@containers/html-utils'
import {useStatsPageStore} from './stats-page-store'
import {toggleChat} from './utils'

type SortField = 'text' | 'plan' | 'work' | 'created' | 'closed' | 'user'
const getSortLabels: () => {[field: string]: string} = () => ({
  text: Lang.msg.tsTaskName,
  plan: Lang.msg.tsPlan,
  work: Lang.msg.tsWork,
  created: Lang.msg.tsCreated,
  closed: Lang.msg.tsCloseDate,
  user: Lang.msg.tsUser
})

export const StatsPageTable = observer(() => {
  const [state, store] = useStatsPageStore()
  const {table, total} = state

  return (
    <>
      <div className={cn('stp-table-head', table.sort.asc && 'sort-asc')}>
        {['user', 'text', 'plan', 'work', 'created', 'closed'].map(
          (col: SortField) => (
            <div
              key={col}
              className={cn(
                'stp-table-head-item',
                table.sort.field === col && 'sort'
              )}
              onClick={() => store.sortChange(col)}
            >
              {getSortLabels()[col]}
            </div>
          )
        )}
      </div>

      <div className="stp-table-wrap">
        <table className="stp-table">
          <tbody>
            {table.tasks.slice(0, 1000).map(task => (
              <tr key={task.id}>
                <td>
                  <UserAvatar user={task.user} />
                </td>
                <td>
                  <span
                    onClick={() => toggleChat(task.id)}
                    className={cn('_link', !task.open && 'closed')}
                  >
                    {task.name}
                  </span>
                </td>
                <td>{task.plan}</td>
                <td>{task.work}</td>
                <td>{task.created}</td>
                <td>{task.closed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="stp-table-footer">
        <div className="stp-table-footer-item">Total tasks: {total.count}</div>
        <div className="stp-table-footer-item" />
        <div className="stp-table-footer-item">{total.plan}</div>
        <div className="stp-table-footer-item">{total.work}</div>
        <div className="stp-table-footer-item" />
        <div className="stp-table-footer-item" />
      </div>
    </>
  )
})
